import { Auth } from 'aws-amplify';
import { endpoint } from 'gsf-util-react-auth/lib/types';

export const api_host_suffix = (() => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'prod':
      return '.api.goldspot.ca';
    case 'test':
      return '.test.api.goldspot.ca';
    case 'test2':
      return '.api.test2.als.app';
    default:
      return '.test.api.goldspot.ca';
  }
})()

export const endpoints: endpoint[] = [
  {
    name: 'Company',
    endpoint: `https://company${api_host_suffix}`,
    custom_header: async () => {
      return {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        'Content-Type': 'application/json',
      };
    },
  },
  {
    name: 'Projects',
    endpoint: `https://projects${api_host_suffix}`,
    custom_header: async () => {
      return {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        'Content-Type': 'application/json',
      };
    },
  },
  {
    name: 'Files',
    endpoint: `https://files${api_host_suffix}`,
    custom_header: async () => {
      return {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        'Content-Type': 'application/json',
      };
    },
  },
];
